import { buildProjection, useSettlements } from '@/api';
import { KpiSkeleton, Link } from '@/components';
import SkyIcon from '@/components/icons/SkyIcon';
import IconNumberKpiCard from '@/components/kpi/IconNumberKpiCard';
import { CurrencyValue, Flex, LinkWrapper, Text } from '@blockanalitica/ui';

export default function PEKpi({ skyPrice, skyMarketCap }) {
  const [settlements, error] = useSettlements();

  if (error) {
    throw error;
  }

  if (settlements) {
    const projection = buildProjection(settlements);
    const data = {
      pe_skyeco:
        projection && projection.net_revenue > 0
          ? skyMarketCap / projection.net_revenue
          : null
    };
    return (
      <LinkWrapper
        to="/financials"
        // @ts-ignore
        as={Link}
        variant="kpiCardLinkWithBlendMode">
        <IconNumberKpiCard
          leftIcon={<SkyIcon size="6" />}
          title="Price to Earnings Ratio (based on Projected Revenue)"
          field="pe_skyeco"
          data={data}
          options={{
            valueFontSize: '5',
            linkArrow: true
          }}
          footerContent={
            <Flex justifyContent="flex-start" flex="1">
              <Flex
                flexDirection={['row', 'row']}
                gap="xs"
                alignItems={'baseline'}>
                <Flex gap="3xs" alignItems={'baseline'}>
                  <Text className="muted">SKY price:</Text>
                  <CurrencyValue
                    color="white"
                    value={Number(skyPrice).toFixed(3)}
                    options={{
                      currency: 'USD'
                    }}
                    fontSize="90"
                  />
                </Flex>
                <Flex gap="3xs" alignItems={'baseline'}>
                  <Text className="muted">Market Cap:</Text>

                  <CurrencyValue
                    color="white"
                    value={skyMarketCap}
                    options={{
                      currency: 'USD'
                    }}
                    fontSize="0"
                  />
                </Flex>
              </Flex>
            </Flex>
          }
        />
      </LinkWrapper>
      //   <LinkWrapper
      //     to="earnings"
      //     // @ts-ignore
      //     as={Link}
      //     variant="kpiCardLinkWithBlendMode">
      //     <KpiCard
      //       title={
      //         <Flex gap="3xs" alignItems="center">
      //           Price to Earnings Ratio
      //           <Tooltip>
      //             <TooltipTrigger>
      //               <InfoIcon size="0" />
      //             </TooltipTrigger>
      //             <TooltipContent>
      //               <Text>
      //                 Ratio is calculated using the Estimate of Annual USDS
      //                 Profits
      //               </Text>
      //             </TooltipContent>
      //           </Tooltip>
      //         </Flex>
      //       }
      //       field="pe"
      //       data={data}
      //       options={{
      //         linkArrow: true,
      //         variants: {
      //           valueCurrencyValue: 'normal'
      //         },
      //         valueOptions: {
      //           currencyValueOptions: {
      //             trendVariant: trendVariantInverted
      //           }
      //         }
      //       }}
      //     />
      //   </LinkWrapper>
    );
  }
  return <KpiSkeleton />;
}
